export default "__VITE_ASSET__CE_1J5D0__"